import { render, staticRenderFns } from "./UsersMenu.vue?vue&type=template&id=536c89fe&"
import script from "./UsersMenu.vue?vue&type=script&lang=js&"
export * from "./UsersMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports